<template>
  <div class="vue timparty-share-button mt-lg-3">

    <span class="small mr-2" v-html="label"></span>

    <span v-if="flgWhatsappActive" class="btn-share px-2" @click="shareOn('whatsapp', text)">
      <img v-if="theme === 'light'" :src="modulePath('/js/src/assets/images/icon-white-whatsapp.png')" class="img-share">
      <img v-else-if="theme === 'dark'" :src="modulePath('/js/src/assets/images/icon-dark-whatsapp.svg')" class="img-share">
      <img v-else-if="theme === 'mgm'" :src="modulePath('js/src/assets/images/portaunamico-wp.png')" class="img-share-mgm">
    </span>

    <span v-if="flgFacebookActive" class="btn-share px-2" @click="shareOn('facebook', text)">
      <img v-if="theme === 'light'" :src="modulePath('/js/src/assets/images/icon-white-facebook.png')" class="img-share">
      <img v-else-if="theme === 'dark'" :src="modulePath('/js/src/assets/images/icon-dark-facebook.svg')" class="img-share">
      <img v-else-if="theme === 'mgm'" :src="modulePath('js/src/assets/images/portaunamico-fb.png')" class="img-share-mgm">
    </span>

    <span v-if="flgTwitterActive" class="btn-share px-2" @click="shareOn('twitter', text)">
      <img v-if="theme === 'light'" :src="modulePath('/js/src/assets/images/icon-white-twitter.png')" class="img-share">
      <img v-else-if="theme === 'dark'" :src="modulePath('/js/src/assets/images/icon-dark-twitter.png')" class="img-share">
    </span>

  </div>
</template>

<script>

/* eslint-disable */

import TimPartyMixin from '../mixins/TimPartyMixin';

export default {
  name: 'ShareButtons',
  mixins: [TimPartyMixin],
  props: {
    label: {
      type: String,
      required: false,
      default: 'Condividi'
    },
    theme: {
      type: String,
      required: false,
      default: 'light'
    },
    text: {
      type: String,
      required: false,
      default: null
    },
    mgmReferralCode: {
      type: String,
      required: false,
      default: null
    },
    mgmReferralPrize: {
      type: String,
      required: false,
      default: null
    },
    facebookActive: {
      type: Boolean,
      required: false,
      default: true
    },
    whatsappActive: {
      type: Boolean,
      required: false,
      default: true
    },
    twitterActive: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  data: function() {
    return {
      flgFacebookActive: this.facebookActive,
      flgWhatsappActive: this.whatsappActive,
      flgTwitterActive: this.twitterActive,
    }
  },

  watch: {
    facebookActive() {
      this.flgFacebookActive = this.facebookActive;
    },
    whatsappActive() {
      this.flgWhatsappActive = this.whatsappActive;
    },
    twitterActive() {
      this.flgTwitterActive = this.twitterActive;
    },
  },

  methods: {
    shareOn: function (target, text) {

      var current_url = window.location.href.split('?')[0];
      var message     = null;
      if (text === null) {
        message = current_url;
      }
      else {
        message = text;
      }

      switch (target) {
        case 'twitter':
          var original_url = current_url;
          current_url      = encodeURIComponent(current_url);
          message          = encodeURIComponent(message);
          if (original_url.includes('/geo/vantaggi')) {
            var browser_url = 'https://twitter.com/intent/tweet?url=' + current_url + '&hashtags=TIMParty,PartyMoments';
          }
          else {
            var browser_url = 'https://twitter.com/intent/tweet?url=' + current_url + '&hashtags=TIMPARTY';
          }

          if (this.user.is_mobile_app) {
            var payload = {
              type: 'tw',
              //shareUrl: 'twitter://post?message='+current_url,
              shareUrl: 'twitter://post?message=' + message,
              browserUrl: browser_url
            };
            this.shareOnApp(payload);
          }
          else {
            window.open(browser_url, '_blank');
          }

          break;
        case 'whatsapp':
          message         = encodeURIComponent(message);
          //var browser_url = 'https://wa.me/?text='+current_url;
          var browser_url = 'https://api.whatsapp.com/send?text=' + message;

          if (this.user.is_mobile_app) {
            var payload = {
              type: "wa",
              shareUrl: 'whatsapp://send?text=' + message,
              browserUrl: browser_url
            };
            this.shareOnApp(payload);
          }
          else {
            window.open(browser_url, '_blank');
          }

          break;
        case 'facebook':
          var original_url = current_url;
          message          = encodeURIComponent(message);


          let getUrl = window.location;
          let baseUrlShare = getUrl .protocol + "//" + getUrl.host;
          let itemEncode = btoa(encodeURIComponent(this.mgmReferralPrize));
          current_url = this.theme === 'mgm' ? encodeURIComponent( baseUrlShare + '/mgm/referral/' + this.mgmReferralCode + '/' + itemEncode) : encodeURIComponent(original_url);
          let current_url_decode = this.theme === 'mgm' ? baseUrlShare + '/mgm/referral/' + this.mgmReferralCode + '/' + itemEncode : original_url;
          // var browser_url = 'https://www.facebook.com/sharer/sharer.php?u=' + current_url + '&hashtag=%23TIMParty&quote=' + message;
          var browser_url = 'https://www.facebook.com/dialog/feed?link=' + current_url + '&hashtag=%23TIMParty&app_id=437617511542189&display=popup&redirect_uri=' + baseUrlShare;

          var payload = {
            type: "fb",
            shareUrl: current_url_decode,
            //browserUrl: browser_url
            browserUrl: current_url_decode
          };
        // } else {
        //   var browser_url = 'https://www.facebook.com/sharer/sharer.php?u=' + current_url + '&hashtag=%23TIMParty';
        //   var payload = {
        //     type: "fb",
        //     shareUrl: original_url,
        //     //browserUrl: browser_url
        //     browserUrl: original_url
        //   };
        //   }

          if (this.user.is_mobile_app) {
            console.log(payload);
            this.shareOnApp(payload);
          }
          else {
            window.open(browser_url, '_blank');
          }
        break;
      }
    },

    shareOnApp: function (payload) {
      // console.log('OBJ', payload);
      payload = JSON.stringify(payload);
      // console.log('JSON', payload);

      if (!payload) {
        return;
      }

      var w = null;

      if (window.webkit != undefined && window.webkit.messageHandlers != undefined && window.webkit.messageHandlers.openShareUrl != undefined) {
        w = window.webkit.messageHandlers.openShareUrl;
      }
      else if (openShareUrl != undefined) {
        w = openShareUrl;
      }
      else if (window.openShareUrl != undefined) {
        w = window.openShareUrl;
      }
      else {
        console.log('TimParty Debug: openShareUrl is not defined');
        return false;
      }

      if (w) {
        w.postMessage(payload);
      }
    }
  }
}
</script>
